import {useEffect} from "react";
import {useUser} from "UserProvider";
import {replayAdvertisingConsent} from "./consentStore";

/**
 * Thin adapter: report the stored advertising decision whenever an account id becomes known
 * (kitecorp/transferify-api-service#1954).
 *
 * All of the rule lives in {@link replayAdvertisingConsent}; this only supplies the identity and the
 * moment. Keyed on the account id alone, so it runs once per sign-in and again if the identity changes,
 * never on an unrelated re-render.
 */
export function useAdvertisingConsentReplay(): void {
	const [user] = useUser();
	const accountId = user.isLoggedIn ? user.id : null;

	useEffect(() => {
		replayAdvertisingConsent(accountId);
	}, [accountId]);
}
